import { render, staticRenderFns } from "./siteSettings.vue?vue&type=template&id=31c6fa53&scoped=true&"
import script from "./siteSettings.vue?vue&type=script&lang=js&"
export * from "./siteSettings.vue?vue&type=script&lang=js&"
import style0 from "./siteSettings.vue?vue&type=style&index=0&id=31c6fa53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6fa53",
  null
  
)

export default component.exports